import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { uri } from '@bo-client/shared/constants/uri';
import { takeUntil } from 'rxjs/operators';
import { CreateOrUpdateUserDto } from '@bo-client/shared/models/createOrUpdateUserDto';
import { ThemePalette } from '@angular/material/core';
import { ValidatorsService } from '@bo-client/shared/forms/validators.service';
import { RegexToCheckEMail, RegexToCheckPassword } from '@bo-client/shared/forms/forms.validators';

declare let window: any; // Needed on Angular 8+

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  color: ThemePalette = 'warn';

  private compUnsubs$ = new Subject<void>();

  formGroup: FormGroup;

  private entity: CreateOrUpdateUserDto = {};

  public hide = true;
  public isLoading = false;
  public error = false;
  public isOk = false;
  public message = null;

  public isUserMail = false;
  public isPassword = false;
  public isChanged = false;

  constructor(
    private formBuilder: FormBuilder,
    private httpHapService: HttpHapService,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public validatorsService: ValidatorsService
  ) {}

  ngOnInit(): void {
    if (this.data.isLink) {
      this.entity = this.data.entity;
    }
    this.isUserMail = this.data.isUserMail;
    this.isPassword = this.data.isPassword;
    this.createForm();
  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      username: [null],
      password: [null]
    });
    if (this.isUserMail) {
      this.formGroup
        .get('username')
        .setValidators([Validators.required, Validators.pattern(RegexToCheckEMail)]);
    }
    if (this.isPassword) {
      this.formGroup
        .get('password')
        .setValidators([Validators.required, Validators.pattern(RegexToCheckPassword)]);
    }
  }

  requestNewPassword() {
    this.isLoading = true;
    this.entity.mail = this.formGroup.get('username').value;
    this.entity.password = '';
    this.entity.resetPasswordToken = '';
    // use code field to send the current domain
    const parsedUrl = new URL(window.location.href);
    const baseUrl = parsedUrl.origin;
    this.entity.code = parsedUrl.origin;
    this.httpHapService
      .create(this.entity, uri.tmChangePwd)
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe((res) => {
        this.isLoading = false;
        this.processResponse(res);
      });
  }

  changePassword() {
    this.isLoading = true;
    this.entity.password = this.formGroup.get('password').value;
    this.httpHapService
      .create(this.entity, uri.tmChangePwd)
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe((res) => {
        this.isLoading = false;
        this.processResponse(res);
      });
  }

  processResponse(res: any) {
    this.isUserMail = false;
    this.isPassword = false;
    this.message = '';

    if (res.type == 'ok') {
      this.isOk = true;
      if (res.message.indexOf('OK_SEND_KEY') !== -1) {
        this.message = this.message + 'Wir haben Ihnen einen Link an Ihre Adresse geschickt';
      }
      if (res.message.indexOf('OK_COMPLETE') !== -1) {
        this.message = this.message + 'Ihre Passwort wurde geändert';
        this.isChanged = true;
        this.isUserMail = false;
        this.isPassword = false;
      }
    } else {
      this.error = true;
      if (res.message.indexOf('ERROR_MAIL_DOES_NOT_EXIST') !== -1) {
        this.message = this.message + 'Ungültige E-Mail';
      }
      if (res.message.indexOf('ERROR_KEY_TIME_OVER') !== -1) {
        this.message = this.message + 'ERROR_KEY_TIME_OVER';
      }
      if (res.message.indexOf('ERROR_KEY_DOES_NOT_MATCH') !== -1) {
        this.message = this.message + 'ERROR_KEY_DOES_NOT_MATCH';
      }
    }
  }

  get email() {
    return this.formGroup.get('username') as FormControl;
  }

  get password() {
    return this.formGroup.get('password') as FormControl;
  }

  closeModal(isOk: boolean) {
    // this.loginService.redirectToHome();
    this.dialogRef.close(isOk);
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
